import { useToast } from "@/components/ui/toast";
import { i18n } from "@/i18n";
import { AppwriteException } from "appwrite";
import { AxiosError } from "axios";
import { ZodError } from "zod";

export type CustomError = {
	code: number,
	message: string,
	type: string
}

const { toast } = useToast();

function formattedCustomError(objectError: CustomError) {
	return {
		...objectError,
		message: i18n.t(`apiErrors.${objectError.type}`)
	}
}

export default function handleErrors(error: AppwriteException | AxiosError | ZodError | Error, shouldDisplayInToast = true) {
	let customError: CustomError | undefined;

	if (error instanceof AppwriteException) {
		customError = formattedCustomError({
			code: error.code,
			message: error.response,
			type: error.type,
		})
	}

	if (error instanceof ZodError) {
		customError = formattedCustomError({
			code: 400,
			type: 'error/bad-request',
			message: '',
		})
	}

	if (error instanceof AxiosError) {
		if (error.response) {
			customError = formattedCustomError(error.response.data as CustomError)
		} else {
			customError = formattedCustomError({
				code: 500,
				message: error.message,
				type: error.code === undefined ? "ERR_NETWORK" : error.code,
			})
		}
	}

	if (customError === undefined) {
		customError = {
			code: 500,
			type: "error/internal-error",
			message:
				import.meta.env.MODE === "staging"
					? error.message
					: i18n.t("apiErrors.error/internal-error"),
		}
	}

	if (shouldDisplayInToast === false) return customError

	toast({
		title: 'Erreur',
		description: i18n.t(`apiErrors.${customError.type}`),
		variant: 'destructive',
	});
}
